var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.622,
    height: 56.622,
    viewBox: "0 0 56.622 56.622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-69.602 -98.508)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 28.311,
    cy: 28.311,
    r: 28.311,
    transform: "translate(69.602 98.508)",
    fill: "#23a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M118.683,129.28l-4.534,16.976-8.287-16.976-8.287,16.976L93.04,129.28,85.378,130.4l10.789,32.837,9.694-19.763,9.694,19.763L126.345,130.4Z",
    transform: "translate(-7.954 -15.513)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.28d6a30e5807dbd28ebeeca6cdf0cf23.svg";
export { ForwardRef as ReactComponent };